// reducers/index.js
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";
import count from "./count";
import versionControl from "./version";
import statisticsControl from "./statistics";
//import dailyOrderControl from "./do_file_list";

//import storageSession from 'redux-persist/lib/storage/session';

const persistConfig = {
  key: "root",
  // redux-persist configuration (retains slices in browser storage);
  // we intentionally do not persist auth token here anymore.
  storage,
  // whitelist/blacklist may be used to pick slices if needed
};

export const rootReducer = combineReducers({
  counterReducer : persistReducer(persistConfig, count),
  versionReducer : persistReducer(persistConfig, versionControl),
  statisticsReducer : persistReducer(persistConfig, statisticsControl),
  //dailyOrderFileListReducer : persistReducer(persistConfig, dailyOrderControl),
  //board,
  //studio
});

export default persistReducer(persistConfig, rootReducer);
